import { ConfigRegistryItem } from '../types/configRegistryTypes';

/** config documentId -> GLOBAL value, from ConfigRegistryApis.getGlobalConfigValues */
export type GlobalConfigValues = Map<string, string>;

/**
 * GLOBAL template value for display / add-to-template flows.
 *
 * Resolution order:
 *  1. `templateItems` — populated only by the with-template APIs
 *  2. `globalValues` — the GLOBAL map, for rows from APIs that don't populate
 *     templateItems (the configs list, another template's value rows)
 *  3. `config.value` — the value of whichever template the row came from, so it
 *     is a GLOBAL default only when that template IS GLOBAL. Ranks last to stop
 *     a sibling template's value masquerading as the default.
 */
export function getConfigGlobalValue(
  config: ConfigRegistryItem & { value?: string | null },
  globalValues?: GlobalConfigValues
): string {
  const fromTemplate = config.templateItems?.[0]?.value;
  if (fromTemplate !== undefined && fromTemplate !== null) {
    return String(fromTemplate);
  }
  const fromGlobal = config.documentId ? globalValues?.get(config.documentId) : undefined;
  if (fromGlobal != null && fromGlobal !== '') {
    return String(fromGlobal);
  }
  if (config.value != null && config.value !== '') {
    return String(config.value);
  }
  return '';
}
